export const ACCEPTANCE_ATTACHMENT_KIND_MEDIA = 'MEDIA';
export const ACCEPTANCE_ATTACHMENT_KIND_REMARK = 'REMARK';

export interface AcceptanceInspectionItem {
  itemId?: number;
  sortOrder?: number | null;
  itemName: string;
  descriptionText?: string | null;
  standardText?: string | null;
  methodText?: string | null;
  sample1?: string | null;
  sample2?: string | null;
  sample3?: string | null;
  sample4?: string | null;
  sample5?: string | null;
  judgment?: string | null;
}

export interface AcceptanceInspectionAttachment {
  attachmentId: number;
  attachmentKind?: string | null;
  fileName: string;
  contentType?: string | null;
  fileSize?: number | null;
  createdAt?: string | null;
}

export interface AcceptanceInspection {
  inspectionId: number;
  productId?: number | null;
  inventoryId?: number | null;
  purchaseOrderId?: number | null;
  contractId?: number | null;
  itemKind?: string | null;
  itemName?: string | null;
  productName?: string | null;
  productCode?: string | null;
  formId?: number | null;
  formTitle?: string | null;
  authorName?: string | null;
  reviewerName?: string | null;
  approverName?: string | null;
  approverUserId?: number | null;
  canRevoke?: boolean | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  status: string;
  specText?: string | null;
  lotNo?: string | null;
  material?: string | null;
  incomingQty?: string | null;
  /** 승인된 중간검사 투입 누적 사용량 */
  consumedQty?: string | null;
  /** 입고 − 사용 (Lot 잔량) */
  remainingQty?: string | null;
  inspectorName?: string | null;
  vendorName?: string | null;
  vendorContactName?: string | null;
  vendorPhone?: string | null;
  incomingDate?: string | null;
  inspectionDate?: string | null;
  categoryLabel?: string | null;
  overallJudgment?: string | null;
  remark?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  items?: AcceptanceInspectionItem[] | null;
  attachments?: AcceptanceInspectionAttachment[] | null;
}

export interface AcceptanceInspectionPayload {
  productId?: number | null;
  inventoryId: number;
  purchaseOrderId?: number | null;
  contractId?: number | null;
  itemName?: string;
  formId?: number | null;
  formTitle?: string;
  authorName?: string;
  status?: string;
  specText?: string;
  lotNo?: string;
  material?: string;
  incomingQty?: string;
  inspectorName?: string;
  vendorName?: string;
  vendorContactName?: string;
  vendorPhone?: string;
  incomingDate?: string | null;
  inspectionDate?: string | null;
  categoryLabel?: string;
  overallJudgment?: string;
  remark?: string;
  items?: AcceptanceInspectionItem[];
}

export interface AcceptanceItemSuggestion {
  inventoryId: number;
  itemKind?: string | null;
  itemName: string;
  specText?: string | null;
}

export function acceptanceItemLabel(row: Pick<AcceptanceInspection, 'itemName' | 'productName'>) {
  return row.itemName?.trim() || row.productName?.trim() || '-';
}

export function acceptanceStatusLabel(
  status?: string | null,
  approvalInProgress?: boolean | null
) {
  if (approvalInProgress) return '결재 요청 중';
  switch (status) {
    case 'APPROVED':
      return '승인완료';
    case 'COMPLETED':
      return '등록완료';
    case 'DRAFT':
      return '작성중';
    default:
      return status || '-';
  }
}

export function isMediaAttachment(file: AcceptanceInspectionAttachment) {
  return (file.attachmentKind || ACCEPTANCE_ATTACHMENT_KIND_MEDIA) !== ACCEPTANCE_ATTACHMENT_KIND_REMARK;
}

export function isRemarkAttachment(file: AcceptanceInspectionAttachment) {
  return file.attachmentKind === ACCEPTANCE_ATTACHMENT_KIND_REMARK;
}

export const EMPTY_ACCEPTANCE_ITEM: AcceptanceInspectionItem = {
  itemName: '',
  descriptionText: '',
  standardText: '',
  methodText: '',
  sample1: '',
  sample2: '',
  sample3: '',
  sample4: '',
  sample5: '',
  judgment: '',
};
